import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Utility } from '../../utility/utility';
import { DatePipe } from '@angular/common';
@Component({
    selector: 'app-date-inp',
    templateUrl: './date-inp.component.html',
    styleUrls: ['./date-inp.component.scss']
  })
export class DateInputComponent implements OnInit, OnChanges {
    @Input() public class: string;
    @Input() public strDate: string;
    @Input() public strId: string;
    public strModel = '';
    isFocus = false;
    init = true;
    lstAcceptKey = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
    @Output() evReturn = new EventEmitter<string>();
    @Output() eRemove = new EventEmitter<string>();
    @Output() eInp = new EventEmitter<string>();
    constructor(public translate: TranslateService, public util: Utility, private dt: DatePipe) {
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (!this.util.isNullOrEmpty(changes) && !this.util.isNullOrEmpty(changes.strDate)
            && !this.util.isNullOrEmpty(changes.strDate.currentValue)) {
                this.strModel = this.FormatDate(changes.strDate.currentValue);
        } else {
            this.strModel = '';
        }
        this.evReturn.emit(this.strModel);
    }
    ngOnInit(): void {
        if (this.util.isNullOrBlank(this.strModel)) {
            this.evReturn.emit(this.strModel);
        }
    }
    GetTypeDate() {
        if (this.init){
            this.init = false;
            return true;
        }
        if (this.util.isNullOrBlank(this.strModel) && !this.isFocus){
            return false;
        }
        return true;
    }
    OnChange(){
        this.isFocus = false;
        this.evReturn.emit(this.strModel);
    }
    focusIn() {
        this.isFocus = true;
    }
    PlaceHolder() {
        const strLang = navigator.language || window.navigator.language;
        if (strLang === 'ja') {
            return '1990/01/01';
        } else {
            return '01/01/1990';
        }
    }
    InpChange() {
        this.eInp.emit();
    }
    FormatDate(pStr: string) {
        let str = this.util.ReplaceAll(pStr, '/', '');
        str = this.util.ReplaceAll(pStr, '-', '');
        if (str.length < 4 || str.length > 8) {
            return str;
        }
        let ret = str.substring(0, 4) + '-';
        if (str.length >= 6) {
            ret += str.substring(4, 6) + '-';
            ret += str.substring(6);
        } else {
            ret += str.substring(4);
        }
        return ret;
    }
    remove(e: any){
        const key = e.key;
        if (key === 'Backspace' || key === 'Delete') {
            this.eRemove.emit();
        }
        if (this.lstAcceptKey.includes(key)){
            return true;
        }
        if (isNaN(key) || +key < 0 || +key > 9 || this.util.isNullOrBlank(key)) {
            e.preventDefault();
            return false;
        }
        return true;
    }
}
